import { render } from "./Chat.vue?vue&type=template&id=62c2e1b3&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=62c2e1b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c2e1b3"]])

export default __exports__